import moment from 'moment';

const useDateFormat = () => {
	return moment.localeData().longDateFormat('L');
};

export default useDateFormat;
